export default "__VITE_ASSET__CtXQWb$2__"